import { useContext } from "react";
import { useSelector } from "react-redux";
import { Id, Identifiable, Log, WeeklyCalendar } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  logs: Identifiable<Log>[];
  numberPages: number;
  retrievePlanzoneLogs(
    request: Boundaries["retrievePlanzoneLogs"]["request"],
  ): void;
}

function useRetrievePlanzoneLogs(planzoneId: Id): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isPlanzoneLogsRetrievalRequestPending(planzoneId),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isPlanzoneLogsRetrievalRequestSuccess(planzoneId),
    ),
    isRequestFailure: useSelector(() =>
      selector.isPlanzoneLogsRetrievalRequestFailure(planzoneId),
    ),
    logs: useSelector(() => selector.getPlanzoneLogs(planzoneId).logs),
    numberPages: useSelector(() => selector.getPlanzoneLogs(planzoneId).pages),
    retrievePlanzoneLogs: core.retrievePlanzoneLogs,
  };
}

export { useRetrievePlanzoneLogs };
